module.exports = __webpack_public_path__ + "img/epr-price_medium@2x.a495ec62.jpg";